import clsx from 'clsx';
import { Outlet } from 'react-router';
import { NavigationView } from './nav';

export function RootLayout() {
  return (
    <main className={clsx('h-screen w-full flex flex-col justify-between')}>
      <div className="h-full overflow-auto no-scrollbar overscroll-none px-4 pt-4">
        <Outlet />
      </div>

      <NavigationView />
    </main>
  );
}
